export default "__VITE_ASSET__bd5e8568__"